import React from "react";
import { css } from "@emotion/react";
import { Font, FieldLabel } from "@moneyforward/mfx_biz_react_components";
import { FormErrorMessage, FormSelectBox } from "@/components/molecules";
import { useIsSpMode } from "@/hooks";
import { BankBranchOffice } from "@/generated/graphql";
import config from "@/libs/config";

type Props = {
  name: string;
  branchOffices: BankBranchOffice[];
  labelRequired: boolean;
  isDisabled: boolean;
};

export const BranchOfficeFormField = (props: Props) => {
  const isSpMode = useIsSpMode();
  const branchOfficeOptions = props.branchOffices
    .filter((b) => !b.isHeadOfficeOn)
    .filter((b) => b.branchOfficeCode || b.branchOfficeName)
    .sort((a, b) => {
      return a.branchOfficeCode.localeCompare(b.branchOfficeCode);
    })
    .map((b) => {
      if (b.branchOfficeCode && !b.branchOfficeName) {
        return { label: b.branchOfficeCode, value: b.branchOfficeId };
      } else if (!b.branchOfficeCode && b.branchOfficeName) {
        return { label: b.branchOfficeName, value: b.branchOfficeId };
      }
      return {
        label: `${b.branchOfficeName}（${b.branchOfficeCode}）`,
        value: b.branchOfficeId,
      };
    });
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <FieldLabel
          isRequired={props.labelRequired}
          helpMessage={
            <Font variant="s">
              {config.BANK_NAME}
              の口座をお持ちの方はメインの取引先支店を、お持ちでない方はMikatano
              インボイス管理を紹介された行職員の所属支店を選択してください。
            </Font>
          }
        >
          取引支店
        </FieldLabel>
      </div>
      <div css={inputWrapper}>
        <div css={fieldWrapper}>
          <FormSelectBox
            name={props.name}
            placeholder={"未選択"}
            options={branchOfficeOptions}
            registerOptions={{
              required: "選択してください",
            }}
            isDisabled={props.isDisabled}
          />
          <FormErrorMessage name={props.name} />
        </div>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  display: "flex",
  alignItems: "center",
});

const fieldWrapper = css({
  width: "398px",
});
